enum EcoFeeModalEnum {
	ecoFeeCard = 'ecoFeeCard'
}

export default EcoFeeModalEnum;
